/** The default sequence of the primary navigation, shared by every shell presentation.
 *
 *  Top to bottom: where you land, then project context, then administration. This is only the UNTOUCHED
 *  default, a user's own arrangement overrides it entirely, but it has to be the same default everywhere,
 *  or switching the design would silently re-sort a menu nobody touched. Plugin worlds stay dynamic and
 *  follow the live manifest listing rather than being special-cased.
 *
 *  This is the navigation MODEL's ordering rule, not a presentation detail, which is why it lives beside
 *  navEntry.ts rather than inside the component that happened to need it first. */
const NAV_ROUTE_ORDER = [
  '/dash', '/chat',
  '/projects',
  '/account', '/users', '/settings', '/guides', '/p/changelog',
];

/** Where an entry parks in that sequence. Prefix matching lets a core route's nested pages share its slot;
 *  an unmatched dynamic plugin follows the live listing order. */
export function navOrderIndex(href: string | undefined): number {
  if (!href) return Number.MAX_SAFE_INTEGER;
  const index = NAV_ROUTE_ORDER.findIndex((route) => href === route || href.startsWith(`${route}/`));
  return index < 0 ? Number.MAX_SAFE_INTEGER : index;
}
